import React, { useEffect } from "react";
import Navbar from "../../components/Navbar/navbar";
import { Outlet } from "react-router";
import { SocketProvider } from "../../app/socket";
import { calls } from "../../config/db_config";
import { tokenUtils } from "../../utils/token-utils";
import { setProfileData } from "../../components/Navbar/navbarSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ChatProvider } from "./chatContext";

const WithNav = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const studentExcludePaths = [
    "/exams-admin",
    "/exams-submitted",
    "quiz-admin",
    "/users",
    "/dashboard",
    "/settings",
  ];
  const parentExludePaths = [
    "/exams-admin",
    "/exams-submitted",
    "quiz-student",
    "quiz-admin",
    "/users",
    "/dashboard",
    "/settings",
  ];
  const professorExcludePaths = [""];

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        const res = await fetch(calls.getUserData, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: tokenUtils.getBearerToken(),
          },
        });

        const data = await res.json();
        console.log("[WithNav] getUserData ->", res.status, data);

        if (cancelled) return;

        if (res.ok && data.status === 200) {
          let profileData = data.data;
          dispatch(setProfileData(profileData));

          const pathname = window.location.pathname;

          if (profileData.user_type === "student") {
            if (studentExcludePaths.includes(pathname)) {
              navigate("/");
            }
          } else if (profileData.user_type == "parent") {
            if (parentExludePaths.includes(pathname)) {
              navigate("/");
            }
          } else if (
            profileData.user_type === "professor" ||
            profileData.user_type === "admin"
          ) {
            if (professorExcludePaths.includes(pathname)) {
              navigate("/");
            }
          }

          if (profileData.is_archived == 1 || profileData.is_archived == 2) {
            navigate("/login");
          }
        } else {
          navigate("/login");
        }
      } catch (e) {
        navigate("/login");
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [dispatch, navigate]); // ✅ run once

  return (
    <>
      <SocketProvider>
        <ChatProvider>
          <Navbar />
        </ChatProvider>
        <Outlet />
      </SocketProvider>
    </>
  );
};

export default WithNav;
